// Canonical active environment for the BigCommerce Site Content admin (PDP/PCP
// authoring). One selected value drives BOTH the BC store the admin edits (via
// bc-proxy) and the env-scoped Neon rows (pdp_defaults), so authoring on SB-1
// (or PROD) targets that environment everywhere. Persisted so it survives
// reloads. Default sb2 (where PDP config is built). PROD is selectable but
// gated behind a confirm dialog in the UI (SiteContent) so it can't be chosen
// by accident; the promoter pipeline remains the controlled path for bulk
// prod promotion.
const KEY = 'cpx.activeEnv';
const VALID = ['sb2', 'sb1', 'prod'];

export function getActiveEnv() {
  try {
    const v = window.localStorage.getItem(KEY);
    return VALID.includes(v) ? v : 'sb2';
  } catch (e) {
    return 'sb2';
  }
}

export function setActiveEnv(env) {
  if (!VALID.includes(env)) throw new Error('invalid env: ' + env);
  try { window.localStorage.setItem(KEY, env); } catch (e) {}
  return env;
}

// Map the canonical env (sb2/sb1/prod) to the bc-proxy `store` string.
export function bcStoreForEnv(env) {
  if (env === 'sb1') return 'sandbox-1';
  if (env === 'prod') return 'production';
  return 'sandbox-2';
}
